import React from "react";

export default function Policies() {
	return <div>Pagina de politicas</div>;
}
